export const en = {
  app: {
    name: 'Alkisen',
    tagline: 'Cellar in order. Bar ready.',
    motto: 'Scan · stash · mix · cheers',
  },
  nav: {
    cellar: 'Cellar',
    scan: 'Scan',
    nyheter: 'New releases',
    utforsk: 'Explore',
    popular: 'Popular',
    wishlist: 'Wishlist',
    feed: 'Activity',
    friends: 'Friends',
    stats: 'Stats',
    guides: 'Guides',
    racks: 'Racks',
    occasions: 'Occasions',
    pair: 'Food pairing',
    recommend: 'For you',
    labels: 'Labels',
    vinliste: 'Wine list',
    pricing: 'Pricing automat',
    bestilling: 'Orders',
    varetelling: 'Stock count',
    pos: 'POS integration',
    profil: 'Public page',
    historikk: 'History',
    abonnement: 'Subscription',
    settings: 'Settings',
    signOut: 'Sign out',
    signIn: 'Sign in',
    scans: 'Scans',
    admin: 'Admin',
  },
  navGroups: {
    discover: 'Discover',
    plan: 'Plan',
    social: 'Social',
    tools: 'Tools',
  },
  landing: {
    heroTitle: 'Alkisen keeps every bottle in line.',
    heroSubtitle: 'Norwegian product data first. When the catalogue does not cover it, Alkisen falls back to wine, spirits and cocktail sources.',
    cta: 'Open the bar',
    ctaSecondary: 'Tell me more',
    feat1Title: 'Snap & know it all',
    feat1Body: 'Point the camera at the label — wine, beer or spirits — and AI pulls producer, type, origin and vintage in seconds.',
    feat2Title: 'Barcode in a blink',
    feat2Body: 'Scan the barcode and match against the primary catalogue first. Backup sources cover bottles outside it.',
    feat3Title: 'Labels with style',
    feat3Body: 'Print pretty QR/barcode labels straight to a Zebra. Your cellar will look like a hotel bar.',
    feat4Title: 'Food pairing',
    feat4Body: 'What are you eating? Meat, fish, chicken or veggie — AI suggests wine, beer or spirits from your shelf or the catalogue.',
    feat5Title: 'Drink mixer',
    feat5Body: 'AI sees what you have and suggests cocktails. It also flags what is missing — so you know what to grab before the next party.',
    feat6Title: 'Guides',
    feat6Body: 'Dehydrate orange slices, batch a syrup, pick the right ice. Short how-to guides right in the app, exactly when you need them.',
    sectionFeatures: 'Built for everyone who loves a good drink',
    sectionStats1: 'Catalogue products',
    sectionStats2: 'Barcode providers',
    sectionStats3: 'Seconds to scan',
    footer: 'Made with love, caffeine and the occasional Negroni.',
  },
  cellar: {
    title: 'The cellar',
    subtitle: '{{count}} bottles · sorted {{sort}}',
    addBottle: 'Add bottle',
    empty: 'Cellar is empty',
    emptyHint: 'Scan a bottle or search the catalogue to begin.',
    searchPlaceholder: 'Search the cellar...',
    filters: {
      all: 'All',
      red: 'Red',
      white: 'White',
      sparkling: 'Sparkling',
      rose: 'Rosé',
      dessert: 'Dessert',
      fortified: 'Fortified',
      drinkSoon: 'Drink soon',
      unread: 'Unrated',
    },
    sort: {
      addedDesc: 'Newest first',
      addedAsc: 'Oldest first',
      nameAsc: 'Name A→Z',
      ratingDesc: 'Highest rated',
      vintageDesc: 'Newest vintage',
    },
    tabs: {
      cellared: 'In cellar',
      drunk: 'Drunk',
      gifted: 'Gifted',
    },
  },
  scan: {
    title: 'Scan',
    subtitle: 'Barcode, QR or label photo — we find the right bottle.',
    auto: 'Auto',
    barcode: 'Barcode',
    qr: 'QR',
    photo: 'Label photo',
    cameraPermissionTitle: 'Camera permission required',
    cameraPermissionBody: 'To scan barcodes or labels, please allow camera access.',
    cameraSecureContextBody: 'Camera access requires HTTPS or localhost. Open the app through https://vin.invested.no once the Traefik route is active.',
    cameraStart: 'Start camera',
    cameraStop: 'Stop camera',
    awaitingCode: 'Hold the bottle still as soon as the barcode is visible.',
    awaitingPhoto: 'Position the label in the frame and tap to capture.',
    capture: 'Capture',
    upload: 'Or upload',
    resolveTitle: 'Result',
    resolveMappedTitle: 'We know this bottle',
    resolveCandidatesTitle: 'Choose the right product',
    resolveAiTitle: 'AI-extracted label',
    confirm: 'Confirm this',
    notFound: 'No match. Search manually:',
    addManually: 'Add manually',
    noneMatch: 'None match?',
    photoStack: 'Scanned labels',
    bulkLabels: 'Bulk label scanning',
    bulkLabelsDesc: 'Drop many label photos — AI reads and finds catalogue matches for each',
  },
  scanBulkLabels: {
    title: 'Bulk label scanning',
    subtitle: 'Drop many label photos — we analyse each and find catalogue matches.',
    dropHint: 'Drop images here, or select from device',
    analyzeAll: 'Analyse all',
    addAllMatches: 'Add all matches',
    analyzing: 'Analysing…',
    noPictures: 'No images selected',
    noPicturesHint: 'Select or drop label images above to get started.',
    retryItem: 'Retry',
    retryAllFailed: 'Retry all failed',
  },
  duplicate: {
    title: 'Already in cellar',
    body: '"{{name}}" appears to already be in your cellar.',
    addAnother: 'Add another',
    otherVintage: 'Different vintage',
    skip: 'Skip (duplicate)',
    vintageLabel: 'Confirm or change the vintage',
  },
  bottle: {
    backToCellar: 'Back to cellar',
    rateThis: 'Rate this bottle',
    yourRating: 'Your rating',
    notes: 'Notes',
    placeholderNotes: 'How was it? Aroma, taste, finish...',
    save: 'Save',
    saved: 'Saved',
    similar: 'Similar wines',
    sales: 'Sales last 12 months',
    addLabel: 'Add to label queue',
  },
  racks: {
    title: 'Racks',
    subtitle: 'Drag bottles between racks and slots.',
    new: 'New rack',
    layout: 'Layout',
    rows: 'Rows',
    cols: 'Columns',
  },
  occasions: {
    title: 'Occasions',
    subtitle: 'Playlists of bottles for different evenings.',
    new: 'New occasion',
    bbq: 'BBQ',
    christmas: 'Christmas dinner',
    tuesday: 'Tuesday red',
    anniversary: 'Anniversary',
    party: 'Party',
  },
  labels: {
    title: 'Labels',
    subtitle: 'Build, preview, and print.',
    queue: 'Print queue',
    new: 'New label',
    preview: 'Preview',
    print: 'Print',
    reprint: 'Print again',
    retryPrint: 'Try again',
    duplicate: 'Duplicate',
    delete: 'Delete',
    pause: 'Pause',
    resume: 'Resume',
    clearCompleted: 'Clear completed',
    fields: {
      productName: 'Product name',
      cuvee: 'Cuvée',
      producer: 'Producer',
      vintage: 'Vintage',
      region: 'Region',
      country: 'Country',
      wineClass: 'Class',
      typeCode: 'Type',
      valueRange: 'Price range',
      foodPairings: 'Food pairings',
      occasion: 'Occasion',
      barcode: 'Barcode',
    },
    statuses: {
      pending: 'Pending',
      queued: 'Queued',
      printing: 'Printing',
      printed: 'Printed',
      completed: 'Completed',
      done: 'Done',
      failed: 'Failed',
      paused: 'Paused',
      cancelled: 'Cancelled',
    },
  },
  pricing: {
    title: 'Pricing automat',
    subtitle: 'Set purchase and selling prices for cellared bottles — {{count}} bottles',
    tabPricing: 'Pricing',
    tabQuantity: 'Quantity & location',
    tabHistory: 'History',
    tabDetails: 'Details',
    purchasePriceExVat: 'Purchase price ex. VAT',
    purchasePriceIncVat: 'Purchase price inc. VAT',
    sellingPrice: 'Selling price',
    lockPrice: 'Lock selling price',
    lockPriceHint: 'The pricing automat never touches a locked price',
    marketPrice: 'Market price (catalogue)',
    marketPriceUpdated: 'updated {{date}}',
    marketPriceNone: 'No catalogue price found',
    suggestedPrice: 'Suggested price',
    applySuggested: 'Apply suggested',
    sellBuyRatio: 'Sell/buy ratio',
    costOfGoods: 'Cost of goods',
    surcharge: 'Surcharge',
    glassPrice: 'Price per glass',
    glassSize: 'Glass size',
    soldByGlass: 'Sold by the glass',
    supplier: 'Supplier',
    noBasis: 'Set a purchase price to calculate',
    columns: {
      name: 'Name',
      purchase: 'Purchase',
      market: 'Market price',
      selling: 'Selling price',
      suggested: 'Suggested',
      ratio: 'Ratio',
      glass: 'Glass',
    },
    bulk: {
      selected: '{{count}} selected',
      applySuggestedToSelected: 'Apply suggested price to selected',
      applyMarkupToSelected: 'Set markup on selected',
      markupPlaceholder: 'e.g. 2.8',
      apply: 'Apply',
      updated: '{{count}} prices updated',
      skippedLocked: '{{count}} locked bottles were skipped',
    },
    empty: 'No bottles in the cellar yet',
    quantity: {
      qty: 'Quantity',
      rack: 'Location',
      noRack: 'Unassigned',
      location: 'Location',
      pendingDelivery: 'Pending delivery',
      pendingDeliveryHint: 'Ordered/on the way, not yet physically placed',
    },
    history: {
      empty: 'No history yet',
      events: 'Events',
      eventsEmpty: 'No recorded events yet',
      remaining: '{{qty}} remaining',
      tastingNotes: 'Tasting notes',
      tastingNote: 'Tasting note',
      drunkAt: 'Drunk',
    },
    sell: {
      action: 'Sell',
      title: 'Sell bottle',
      quantity: 'Quantity',
      unitPrice: 'Price per bottle',
      note: 'Note',
      confirm: 'Confirm sale',
      success: 'Sale recorded',
      partial: 'Only {{applied}} of {{requested}} bottles were in stock',
    },
    marketValue: {
      title: 'Market value',
      none: 'No price history found yet',
      updated: 'updated {{date}}',
      trend: {
        up: 'Rising',
        down: 'Falling',
        flat: 'Unchanged',
      },
      crossMarket: 'Other sources',
      crossMarketEmpty: 'No matches in other sources',
      confidence: {
        ean: 'Barcode match',
        name_vintage: 'Name/vintage match',
      },
    },
  },
  orders: {
    title: 'Orders',
    subtitle: '{{count}} orders',
    new: 'New order',
    empty: 'No orders yet',
    noSupplier: 'No supplier',
    supplier: 'Supplier',
    note: 'Note',
    addLine: 'Add item',
    searchCatalog: 'Search the catalogue...',
    lineName: 'Name',
    quantity: 'Quantity',
    unitPrice: 'Unit price',
    addLineButton: 'Add line',
    noLines: 'No lines yet',
    total: 'Total',
    place: 'Place order',
    placed: 'Order placed',
    markReceived: 'Mark received',
    confirmReceived: 'Confirm received',
    receiveHint: 'Choose where the bottles should be placed (optional).',
    received: 'Order received',
    cancel: 'Cancel',
    cancelled: 'Order cancelled',
    orderedAt: 'Ordered {{date}}',
    receivedAt: 'Received {{date}}',
    status: {
      draft: 'Draft',
      ordered: 'Ordered',
      received: 'Received',
      cancelled: 'Cancelled',
    },
  },
  stockCount: {
    title: 'Stock count',
    subtitle: '{{count}} counts',
    new: 'New count',
    empty: 'No counts yet',
    noLines: 'No bottles match the search',
    searchPlaceholder: 'Search the count...',
    applySwitch: 'New count becomes cellar count',
    applySwitchHint: 'When the count is completed, bottle quantities are updated to match what was counted',
    progress: '{{done}} of {{total}} confirmed',
    complete: 'Complete',
    completed: 'Stock count completed',
    adjusted: '{{count}} bottles adjusted',
    exportPdf: 'Export PDF',
    unassigned: 'Unassigned',
    decrease: 'Decrease quantity',
    increase: 'Increase quantity',
    confirmLine: 'Confirm line',
    columns: {
      wine: 'Wine',
      vintage: 'Vintage',
      volume: 'Volume',
      purchasePrice: 'Purchase price',
      location: 'Location',
      cellar: 'Cellar',
      newCount: 'New count',
    },
    status: {
      open: 'Open',
      completed: 'Completed',
    },
  },
  pos: {
    title: 'POS integration',
    subtitle: 'Connect a point-of-sale system to Alkisen — every bottle sold is deducted from the cellar automatically.',
    keys: {
      title: 'API keys',
      new: 'New key',
      namePlaceholder: 'e.g. Register 1',
      empty: 'No API keys yet',
      created: 'Key created',
      createdHint: 'Copy the key now — it will never be shown again.',
      copy: 'Copy',
      copied: 'Copied',
      revoke: 'Revoke',
      revoked: 'Revoked',
      revokeConfirm: 'Revoke this key? POS systems using it will no longer be able to report sales.',
      lastUsed: 'Last used {{date}}',
      neverUsed: 'Never used',
      createdAt: 'Created {{date}}',
    },
    docs: {
      title: 'Integration',
      description: 'POST every sold bottle to the endpoint below, authenticated with the API key in the header.',
      endpoint: 'Endpoint',
      header: 'Header',
      example: 'Example',
      fields: 'externalId is an idempotency key — the same externalId sent twice is only ever applied once. Matches on bottleId, catalogId, or name (in that order).',
    },
    recentSales: {
      title: 'Recent sales',
      empty: 'No POS sales recorded yet',
    },
  },
  history: {
    title: 'Cellar history',
    subtitle: 'Full log of everything that happens in the cellar.',
    empty: 'No events yet',
    filters: {
      all: 'All',
    },
    columns: {
      date: 'Date',
      activity: 'Activity',
      wine: 'Wine',
      bottles: 'Bottles',
      remaining: 'Remaining',
      buy: 'Buy',
      sell: 'Sell',
    },
    activity: {
      added: 'Added',
      drunk: 'Drunk',
      gifted: 'Gifted',
      sold: 'Sold',
      adjusted: 'Adjusted',
      moved: 'Moved',
      received: 'Received',
      counted: 'Counted',
    },
  },
  settings: {
    title: 'Settings',
    language: 'Language',
    languageNb: 'Norsk',
    languageEn: 'English',
    theme: 'Theme',
    apiKeys: 'API keys',
    catalog: 'Catalogue',
    syncCatalog: 'Sync catalogue',
    members: 'Members',
    aboutTitle: 'About Alkisen',
  },
  common: {
    loading: 'Loading...',
    error: 'Something went wrong',
    retry: 'Retry',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    confirm: 'Confirm',
    delete: 'Delete',
    add: 'Add',
    none: 'None',
    optional: 'optional',
    yes: 'Yes',
    no: 'No',
  },
};
